import navigateToURLWithQueryParams from '../../../utils/navigateToURLWithQueryParams';
import { disableScrolling, enableScrolling } from '../../../utils/scrollingOverride';

const updatePhoneFilter = ({
  category,
  item,
  search,
  locale,
}: {
  category: string;
  item: string;
  search: string;
  locale: string;
}) => {
  const params = new URLSearchParams(search.replace(/\/$/, ''));

  const parameterName = category.split('-')[1];
  const value = item.split('-')[2];
  const existingParameter = params.get(parameterName)?.split(' ');
  if (existingParameter != null) {
    // Already have some value for this param
    // Check if value is there
    if (existingParameter.includes(value)) {
      const updated = existingParameter.filter((p) => p !== value).join(' ');
      if (updated === '') {
        params.delete(parameterName);
      } else {
        params.set(parameterName, updated);
      }
    } else {
      existingParameter.push(value);
      params.set(parameterName, existingParameter.join(' '));
    }
  } else {
    // No value for this category
    params.append(parameterName, value);
  }
  disableScrolling();
  navigateToURLWithQueryParams({ locale, basePath: 'phones', params });
  setTimeout(enableScrolling, 1000);
};

export default updatePhoneFilter;
